import React from 'react';

import { Web } from './Web';
import { Mobile } from './Mobile';

type CartSurplusItensAlertProps = {
  type?: 'WEB' | 'MOBILE'
}

export function CartSurplusItensAlert({
  type = 'WEB'
}: CartSurplusItensAlertProps) {
  return (
    type === 'WEB' ? (
      <Web />
    ) : (
      <Mobile />
    )
  );
}